"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const popper_placement_modifier_1 = require("./popper-placement-modifier");
const theme_1 = require("./theme");
const AutocompleteDropdown = ({ children, inputHeight = 0, ...props }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: (theme) => ({
                    position: "absolute",
                    left: 0,
                    right: 0,
                    width: "100%",
                    height: `calc(100% + ${inputHeight}px)`,
                    boxShadow: theme.boxShadows.md,
                    pointerEvents: "none",
                    borderRadius: `${theme_1.textFieldBorderRadius}px`,
                    [`${popper_placement_modifier_1.popperPlacementSelectors.top} &`]: {
                        bottom: -inputHeight,
                    },
                    [`${popper_placement_modifier_1.popperPlacementSelectors.topStart} &`]: {
                        bottom: -inputHeight,
                    },
                    [`${popper_placement_modifier_1.popperPlacementSelectors.bottom} &`]: {
                        top: -inputHeight,
                    },
                    [`${popper_placement_modifier_1.popperPlacementSelectors.bottomStart} &`]: {
                        top: -inputHeight,
                    },
                }), "aria-hidden": true }), (0, jsx_runtime_1.jsx)(material_1.Paper, { ...props, sx: (theme) => ({
                    p: 1,
                    border: 1,
                    boxSizing: "border-box",
                    borderColor: theme.palette.gray[30],
                    boxShadow: "none",
                    [`${popper_placement_modifier_1.popperPlacementSelectors.top} &`]: {
                        borderBottom: 0,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    },
                    [`${popper_placement_modifier_1.popperPlacementSelectors.topStart} &`]: {
                        borderBottom: 0,
                        borderBottomLeftRadius: 0,
                    },
                    [`${popper_placement_modifier_1.popperPlacementSelectors.bottom} &`]: {
                        borderTop: 0,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    },
                    [`${popper_placement_modifier_1.popperPlacementSelectors.bottomStart} &`]: {
                        borderTop: 0,
                        borderTopLeftRadius: 0,
                    },
                    [`.${material_1.autocompleteClasses.listbox}`]: { p: 0 },
                    [`.${material_1.autocompleteClasses.noOptions}`]: { display: "none" },
                    [`.${material_1.autocompleteClasses.option}`]: {
                        borderRadius: 1,
                        my: 0.25,
                        [`&[aria-selected="true"]`]: {
                            backgroundColor: `${theme.palette.blue[20]} !important`,
                        },
                        "&.Mui-focused": {
                            backgroundColor: `${theme.palette.gray[10]} !important`,
                            [`&[aria-selected="true"]`]: {
                                backgroundColor: `${theme.palette.gray[20]} !important`,
                            },
                        },
                    },
                }), children: children })] }));
};
exports.AutocompleteDropdown = AutocompleteDropdown;
